import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {showLoading, hideLoading} from 'react-redux-loading-bar';

import {getCurrentCanvas, getCurrentLayout} from "../../appLayout";
import PingPilotButton from "../../visComponents/pingPilotButton";
import NoInternetOverlay from "../../ui/noInternetOverlay";
import HardcodedCanvasImage from "../../visComponents/hardcodedCanvasImage";
import NotInVisualizerView from "../../selectionWindow/notInVisualizerView";
import SelectionDescriptionCover from "../../selectionWindow/selectionDescriptionCover";
import NotCompatibleView from "../../selectionWindow/notCompatibleView";
import MobileMenu from "../../ui/mobileMenu";
import HomeButton from "../../ui/homeButton";
import MaterialsMainCanvasLayoutButton from "./materialsMainCanvasLayoutButton";
import LoadingSpinner from "../../ui/loadingSpinner";
import {setMaterialsCanvasLoading} from "../../../actions/selectionFunctions";
import MaterialsMainLoading from "./materialsMainLoading";
import {isFeatureNotInVisualizerNow} from "../../visComponents/featuresFunctions";
// import CoBrowsingButton from "../../ui/coBrowsingButton";


const MaterialsMainCanvas = (props) => {

  const {
    canvasExpanding, //ownProps
    canvasCollapsing, //ownProps
    goToBV, //ownProps
    listItemHeight, //ownProps
    features, //ownProps
    canvasImageStyles, //ownProps
    handleUserLoginClick, //ownProps
    activeSubPart, //ownProps
    activeFeature, fabricatorData, isMobile, isPhoneNumberValidated, visualizerNotAvailable, staticCanvasImage,
    activeQuoteIndex, canvasDimensions, mobileNav, showLoading, hideLoading, materialsCanvasClass, wizardGroup,
    showNotCompatibleView, visualizerIsChanging, setMaterialsCanvasLoading,
  } = props;

  const layout = getCurrentLayout();
  // const availableButtons = Math.ceil(this.props.features.length / this.props.featuresPerPage);
  // const maxButtons = (availableButtons > this.state.pageCount) ? this.state.pageCount : availableButtons;
  const {isBackend, jobId, canSaveQuote} = document.kvConfig;


  const fabricatorSettings = fabricatorData.settings;

  const layoutAbbr = (layout.getCurrentLayoutAbbreviation() || "").toLowerCase();

  const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;

  const firstClickDone = activeFeature && activeFeature.getParent().firstClick[activeQuoteIndex];

  const showLockScreen = firstClickDone
    && !activeFeature.dbFeature.unlocked
    && (fabricatorSettings.leadCaptureOnQuote && !(isBackend && jobId && canSaveQuote))
    && !isPhoneNumberValidated && !fabricatorSettings.leadCaptureShoppingCart;

  // const {dbFeature} = activeFeature || {};
  const showHomeButton = !canvasExpanding && isMobile;
  // const showGalleryButton = activeFeature && !this.props.selectionFeatureInfo && !canvasExpanding
  //   && dbFeature.galleryImages && dbFeature.galleryImages.length;
  const showGalleryButton = false;

  const getQuoteEnabled = fabricatorSettings.enableQuote;

  const showVisualizerExpandButton = !canvasExpanding && !visualizerNotAvailable
    && (!fabricatorSettings.leadCaptureShoppingCart || (fabricatorSettings.leadCaptureShoppingCart && isPhoneNumberValidated)
      || (fabricatorSettings.leadCaptureShoppingCart && document.kvConfig.visualizerEntered))
    && !(fabricatorSettings.useCategorySwitching && staticCanvasImage)

  const layers = layout.getLayers(showPlaceHolders);

  const showNotInVisualizerView = !showLockScreen && !canvasExpanding && firstClickDone && activeFeature
    && isFeatureNotInVisualizerNow(activeFeature) && !visualizerNotAvailable && !fabricatorData.isCaesarStone;

  const showNotCompatibleViewReal = !showLockScreen && !canvasExpanding && firstClickDone && activeFeature
    && !isFeatureNotInVisualizerNow(activeFeature) && !visualizerNotAvailable && showNotCompatibleView;

  const canvasClass = "selection-main__image selection-main__image--" + document.kvConfig.visualizerType
    + " selection-main__image--"+layoutAbbr
    + " selection-main__image--scene-"+layout.scene
    + " selection-main__image--"+materialsCanvasClass
    + (canvasExpanding ? " selection-main__image--expanding" : "")
    + (canvasCollapsing ? " selection-main__image--collapsing" : "")
    + ((!layers.length || layers.length === 1) && layout.initialized ? " selection-main__image--no-layers" : "");

  const enableLoader = () => {
    setMaterialsCanvasLoading(true);
    showLoading()
  }

  const disableLoader = () => {
    setMaterialsCanvasLoading(false);
    hideLoading()
  }

  const renderCanvasPosition = (layers, layout) => {
    if (staticCanvasImage) {
      return null
    }
    if (visualizerNotAvailable) {
      return <NotInVisualizerView goToBV={goToBV}
                                  isMobile={isMobile}
                                  listItemHeight={listItemHeight}
                                  allVisualizerNotAvailable={true}
                                  activeFeature={activeFeature}/>
    }
    if (visualizerIsChanging) {
      return <LoadingSpinner/>
    }
    const ImageCanvas = getCurrentCanvas();
    return (
      <ImageCanvas canvasId="selectionCanvas"
                   layers={layers}
                   width={canvasDimensions.width}
                   height={canvasDimensions.height}
                   layoutType={layout.getCurrentLayoutName()}
                   layout={layout}
                   useMouseHovering={false}
                   enableLoader={setMaterialsCanvasLoading}
                   disableLoader={setMaterialsCanvasLoading}
      />
    )
  };


  return(
    <div className="materials-left">
      <NoInternetOverlay/>
      <div className={canvasClass} style={canvasImageStyles}>
        <HardcodedCanvasImage disableLoader={disableLoader} enableLoader={enableLoader}/>
        {renderCanvasPosition(layers, layout)}
        <MaterialsMainLoading/>
        {/*{!showLockScreen && activeFeature && activeFeature.notAvailableInVisualizer ? (*/}
        {/*<div className="selection-main__image-img"*/}
        {/*style={{...styleBkgImage(s3FeatureImagePath(activeFeature.dbFeature))}}/>*/}
        {/*) : null}*/}
        {!showLockScreen && !canvasExpanding && (activeSubPart || wizardGroup) && features.length
          ? <SelectionDescriptionCover activePart={activeSubPart} wizardGroup={wizardGroup}/>
          : null}
        {showLockScreen && !canvasExpanding && !visualizerNotAvailable ? (
          <div className="lock">
            <span className="lock-icon"/>
            <p className="lock-text bold"><FormattedMessage id="quotingTool.canvas.featureIsLocked"/></p>
            <button className="lock-button ui-button3 ui-button3--green" onClick={handleUserLoginClick}>
              {getQuoteEnabled
                ? <FormattedMessage id="quotingTool.canvas.getQuoteButton"/>
                : <FormattedMessage id="quotingTool.canvas.unlockNowButton"/>}
            </button>
          </div>
        ) : null}
        {showNotInVisualizerView ? (
          <NotInVisualizerView goToBV={goToBV}
                               isMobile={isMobile}
                               listItemHeight={listItemHeight}
                               activeFeature={activeFeature}/>
        ) : null}
        {showNotCompatibleViewReal ? <NotCompatibleView /> : null}
        {showHomeButton ?
          mobileNav && mobileNav.length > 0
            ? <MobileMenu smallButton={true}
                          smallButtonClassName={"selection-main__image-button selection-main__image-button--home"}/>
            : <HomeButton className="scart-canvas__button scart-canvas__button--home" />
          : null}
        {/*activeFeature && activeFeature.vanitySize
                ? <span className="selection-main__image-size bold">{activeFeature.vanitySize}"</span>
              : null*/}
        {/*{activeFeature && !canvasExpanding && !this.props.selectionFeatureInfo*/}
        {/*  ? <button className="selection-main__image-button selection-main__image-button--info" onClick={this.goToFeatureInfo}/>*/}
        {/*  : null}*/}
        {showVisualizerExpandButton ? (
          <button className="selection-main__image-button selection-main__image-button--fullscreen" onClick={goToBV}/>
        ) : null}
        {/*{showGalleryButton*/}
        {/*  ? <button className="selection-main__image-button selection-main__image-button--image"*/}
        {/*            onClick={() => this.props.toggleGalleryVisible(true)}/>*/}
        {/*  : null}*/}
        <PingPilotButton/>
        {/*{fabricatorData.isAmericanImport && window.location.href.includes("quotekandb") ? <CoBrowsingButton/> : null}*/}
        <MaterialsMainCanvasLayoutButton showHomeButton={showHomeButton} showGalleryButton={showGalleryButton}/>
      </div>
    </div>
  )

};

MaterialsMainCanvas.propTypes = {
  canvasExpanding: PropTypes.bool,
  canvasCollapsing: PropTypes.bool,
  goToBV: PropTypes.func,
  listItemHeight: PropTypes.number,
  features: PropTypes.array,
  canvasImageStyles: PropTypes.object,
  handleUserLoginClick: PropTypes.func,
  activeSubPart: PropTypes.object,
}

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem} = store.wizardState;
  const {selectionFeatureInfo, showNotCompatibleView, activeFeature, materialsCanvasClass} = store.selectionState;
  const {isPhoneNumberValidated} = store.userState;
  const {visualizerNotAvailable} = store.initialFlowState;
  const {activeQuoteIndex} = store.quotesState;
  // const {staticCanvasImage, bvOpened, bvVisited, canvasDimensions} = store.bathroomVisualizerState;
  const {staticCanvasImage, canvasDimensions, canvasCount} = store.bathroomVisualizerState;
  const {mobileNav} = store.navigationState;
  const fabricatorData = store.fabricatorState;
  const {visualizerIsChanging} = store.serverState;

  return {
    wizardList,
    wizardActiveItem,
    selectionFeatureInfo,
    showNotCompatibleView,
    isPhoneNumberValidated,
    visualizerNotAvailable,
    activeQuoteIndex,
    staticCanvasImage,
    canvasDimensions,
    mobileNav,
    fabricatorData,
    activeFeature,
    materialsCanvasClass,
    canvasCount,
    visualizerIsChanging,
  };
};

const mapDispatchToProps = {
  setMaterialsCanvasLoading,
  showLoading,
  hideLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsMainCanvas)
